<div class="color-picker-dialog" [class.light-theme]="data.isDarkTheme === false">
  <div class="dialog-header">
    <h2>Player Color</h2>
    <button class="close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
      <span class="exit-label">EXIT</span>
    </button>
  </div>

  <div class="dialog-content">
    <!-- Vista de grid de colores preset -->
    @if (!showCustomPicker) {
      <div class="color-grid">
        @for (color of presetColors; track color.hex) {
          <button class="color-option"
                  [class.selected]="selectedColor === color.hex"
                  [style.backgroundColor]="color.hex"
                  [attr.aria-label]="color.name"
                  (click)="selectColor(color.hex)">
            @if (selectedColor === color.hex) {
              <mat-icon class="check-icon">check</mat-icon>
            }
          </button>
        }

        <!-- Botón Personalizado -->
        <button class="color-option custom-option"
                [attr.aria-label]="'Color personalizado'"
                (click)="openCustomPicker()">
          <mat-icon class="palette-icon">palette</mat-icon>
        </button>
      </div>
    }

    <!-- Vista de selector personalizado -->
    @if (showCustomPicker) {
      <div class="custom-picker-section">
        <div class="picker-preview">
          <div class="preview-circle" [style.backgroundColor]="selectedColor"></div>
          <span class="preview-text">{{ selectedColor }}</span>
        </div>

        <div class="color-picker-container">
          <!-- Gradiente de saturación/brillo -->
          <canvas #saturationCanvas
                  class="saturation-canvas"
                  width="280"
                  height="200"
                  (click)="onSaturationClick($event)"
                  (touchstart)="onSaturationTouch($event)">
          </canvas>

          <!-- Slider de matiz (hue) -->
          <canvas #hueCanvas
                  class="hue-canvas"
                  width="280"
                  height="30"
                  (click)="onHueClick($event)"
                  (touchstart)="onHueTouch($event)">
          </canvas>
        </div>

        <div class="custom-picker-actions">
          <button mat-button class="cancel-btn" (click)="cancelCustomPicker()">
            Cancelar
          </button>
          <button mat-raised-button class="confirm-btn" (click)="confirmCustomColor()">
            Aplicar Color
          </button>
        </div>
      </div>
    }
  </div>
</div>
